<script>
export default {
  setup() {
    const items = {
      0: {
        icon: require('../assets/img/statistics-icon.svg'),
        numbersText: '98%',
        text: 'Kundenzufriedenheit',
        class: 'kundenzufriedenheit'
      },
      1: {
        icon: require('../assets/img/statistics-icon.svg'),
        numbersText: '24/7',
        text: 'für Sie erreichbar',
        class: 'erreichbarkeit'
      },
      2: {
        icon: require('../assets/img/statistics-icon.svg'),
        numbersText: '72 Jahre',
        text: 'Erfahrung',
        class: 'erfarhung'
      },
      3: {
        icon: require('../assets/img/statistics-icon.svg'),
        numbersText: '310K',
        text: 'Kunden vertrauen in uns',
        class: 'kunden'
      }
    }
    return {
      items
    }
  }
}
</script>

<template>
  <div class="statistics">
    <div class="statistics-wrapper">
      <div v-for="(item, index) in items" :key="index" class="item" :class="item.class">
        <span class="statistics--item-large-text">{{ item.numbersText }}</span>
        <span class="statistics--item-small-text">{{ item.text }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .statistics {
    width: 100%;
    height: 150px;
    background: #F0F0F0;
    margin-top: 75px;

    @media (max-width: 600px) {
      height: 250px;
    }

    .statistics-wrapper {
      width: 100%;
      height: 100%;
      display: flex;

      @media (max-width: 600px) {
        width: 100%;
        justify-content: space-evenly;
        flex-wrap: wrap;
      }

      .item {
        display: flex;
        gap: 10px;
        flex-direction: column;
        color: #000548;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 25%;

        &.kundenzufriedenheit {
          background: #A2BFE0;
        }

        &.erreichbarkeit {
          background: #DEEEFC;
        }

        &.erfarhung {
          background: #F0F0F0;

          @media (max-width: 600px) {
            background: #A2BFE0;
          }
        }

        &.kunden {
          background: #6084BF;
        }

        @media (max-width: 600px) {
          height: 50%;
          width: 50%;
        }

        @media (max-width: 1024px) {
          background: #deeefc !important;
        }

        .statistics--item-large-text {
          font-weight: 800;
          font-size: 36px;
          line-height: 39.6px;
          text-shadow: -1px -1px;

          @media (max-width: 600px) {
            font-size: 20px;
            line-height: unset;
          }

        }

        .statistics--item-small-text {
          font-weight: 500;
          font-size: 16px;
          line-height: 17.6px;

          @media (max-width: 600px) {
            font-size: 14px;
            line-height: 10px;
          }
        }

        .statistics--item-icon {
          height: 50px;
          width: 50px;
        }
      }
    }
  }
</style>
